import { render, staticRenderFns } from "./ErrorsDialog.vue?vue&type=template&id=b4f23400&scoped=true&"
import script from "./ErrorsDialog.vue?vue&type=script&lang=js&"
export * from "./ErrorsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ErrorsDialog.vue?vue&type=style&index=0&id=b4f23400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f23400",
  null
  
)

export default component.exports